import React, { useEffect, useState } from 'react';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonBackButton, IonButtons } from '@ionic/react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '@/utils/api';
import { OpenedPost } from '@/components/OpenedPost';
import GolfLoading from '@/components/GolfLoading';

interface PostParams {
  postId: string;
}

const PostPage: React.FC = () => {
  const { postId } = useParams<PostParams>();
  const { t } = useTranslation('MGP');
  const [post, setPost] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/posts/${postId}`);
        setPost(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching post:', err);
        setError(t('post_not_found'));
      } finally {
        setLoading(false);
      }
    };

    if (postId) {
      fetchPost();
    }
  }, [postId, t]);

  const handlePostDelete = () => {
    // Handle post deletion - redirect back to previous page
    window.history.back();
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/dashboard" />
          </IonButtons>
          <IonTitle>{t('post')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <GolfLoading />
          </div>
        ) : error ? (
          <div className="flex flex-col items-center justify-center h-full p-4 text-center">
            <p className="text-lg text-gray-500">{error}</p>
          </div>
        ) : post ? (
          <div className="h-full">
            <OpenedPost
              isOpen={true}
              onDidDismiss={() => {}} // No-op since this is a page view
              postId={post.id}
              user={post.user}
              images={post.images}
              likes={post.likes}
              isLiked={post.isLiked}
              course={post.course}
              caption={post.caption}
              comments={post.comments}
              profileId={post.profileId}
              onDelete={handlePostDelete}
              createdAt={post.createdAt}
            />
          </div>
        ) : null}
      </IonContent>
    </IonPage>
  );
};

export default PostPage;
